module.exports = __webpack_public_path__ + "img/fatherhood_10.276a558e.jpg";